import { render, staticRenderFns } from "./FrmSettings.vue?vue&type=template&id=5f772375"
import script from "./FrmSettings.vue?vue&type=script&lang=js"
export * from "./FrmSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports